import UserResults from "./Components/UserResults";

export default UserResults;
